import * as React from 'react'
import { useIntl } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import { MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE } from 'constants/content'
import getValueOffPercent from 'lib/offer/getValueOffPercent'
import PriceDetails from './PriceDetails'

interface Props {
  price?: number
  currencyCode: string
  value?: number
  depositComponent?: React.ReactElement
  className?: string
  cabinCategory?: string
  isOfferAvailable: boolean
}

function CruiseV2SavedPriceDetails({
  price,
  currencyCode,
  value,
  depositComponent,
  className,
  cabinCategory,
  isOfferAvailable,
}: Props) {
  const intl = useIntl()
  const priceLabel = cabinCategory ? intl.formatMessage(
    {
      id: 'PPC4tZNHgeBumRb0GrJN',
      defaultMessage: '{cabinCategory} from',
      description: 'Cruise saved price label with cabin category prefix in the trip planner',
    },
    { cabinCategory },
  ) : intl.formatMessage({
    id: 'oAeGNzW5URhPv0MWXfw2',
    defaultMessage: 'From',
    description: 'Default cruise saved price label when no cabin category is available',
  })

  const soldOutLabel = intl.formatMessage({
    id: 'ksKGFE1Wax_ux6usazyO',
    defaultMessage: 'Sold Out',
    description: 'Label shown when a cruise cabin is no longer available in trip planner',
  })

  if (!isOfferAvailable) {
    return (
      <BodyText variant="large" weight="bold">
        {soldOutLabel}
      </BodyText>
    )
  }

  if (!price) {
    return null
  }

  let discount: number | undefined = value ?
      getValueOffPercent(value, price) :
    0
  if (discount < MINIMUM_DISCOUNT_TO_SHOW_PERCENTAGE_BADGE) {
    discount = undefined
  }

  return (
    <PriceDetails
      currencyCode={currencyCode}
      price={price}
      value={value}
      discount={discount}
      priceLabel={priceLabel}
      depositComponent={depositComponent}
      discountDisplayType="following"
      className={className}
      totalLabel="/person"
    />
  )
}

export default CruiseV2SavedPriceDetails
